import {
  GeofenceSiteGroupFormDefaultValues,
  GeofenceSiteGroupFormProps,
  GeofenceSiteGroupFormRawValues,
  GeofenceSiteGroupFormType
} from "./GeofenceSiteGroupForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

const getInitialValues = (defaultValues: GeofenceSiteGroupFormDefaultValues | undefined): GeofenceSiteGroupFormRawValues => {
  return {
    name: defaultValues?.name,
  }
}

export type UseGeofenceSiteGroupFormProps = Pick<GeofenceSiteGroupFormProps, 'defaultValues'> & {}

export function useGeofenceSiteGroupForm(props: UseGeofenceSiteGroupFormProps): GeofenceSiteGroupFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
